import type { ButtonProps, SubmitButtonProps } from '@capsule/consumer-design-system';
import { Typography, Button, SubmitButton } from '@capsule/consumer-design-system';

import type { AnimationProps } from 'framer-motion';
import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

const CTAFooter = styled(motion.footer)`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${({ theme }) => theme.space.s5};
  background-color: ${({ theme }) => theme.colors.capsuleGreen00};
  flex-shrink: 0;

  z-index: 1;

  & > button {
    width: 100%;
  }
`;

const ErrorContainer = styled(Typography).attrs({ variant: 'small' })`
  color: ${({ theme }) => theme.colors.capsuleRed60};
  text-align: center;

  transition: all ${({ theme }) => theme.animation.typical};
  height: 1.6rem;
  opacity: 1;
  margin-bottom: ${({ theme }) => theme.space.s3};

  &:empty {
    transition: height 0.2s linear;
    height: 0;
    opacity: 0;
    margin-bottom: 0;
  }
`;

export interface EscriptOnboardingStepCTAGroupProps extends AnimationProps {
  className?: string;
  cta1: Omit<ButtonProps, 'variant'> | Omit<SubmitButtonProps, 'variant'>;
  cta2?: Omit<ButtonProps, 'variant'>;
  error?: string | null;
}

export const StylizedFooter = ({
  className,
  cta1,
  cta2,
  error,
  ...animationProps
}: EscriptOnboardingStepCTAGroupProps) => (
  <CTAFooter className={className} {...animationProps}>
    <ErrorContainer role="alert">{error}</ErrorContainer>

    {'isSubmitting' in cta1 ? (
      <SubmitButton {...cta1} variant="contained-secondary-lg" />
    ) : (
      <Button {...cta1} variant="contained-secondary-lg" />
    )}

    {cta2 && (
      <Button
        {...cta2}
        css={css`
          margin-top: ${({ theme }) => theme.space.s3};
        `}
        variant="outline-lg"
      />
    )}
  </CTAFooter>
);
